import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "msi-form" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("提交")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_4 = { class: "msi-content" }
const _hoisted_5 = { class: "header" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("新增")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("编辑 ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("删除 ")
const _hoisted_9 = { class: "dialog-footer" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("确认")

import { ref, reactive, nextTick } from "vue";
import {
  addMenu,
  editMenu,
  getMneusList,
  getMneusTree,
  delMenu
} from "@/service/main/platform";
import { menuTypeList } from "@/utils/enum";
import { ElMessage, ElMessageBox } from "element-plus";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const rowClass = (row: any, column: number, rowIndex: number, columnIndex: number) => {
  if (row.rowIndex === 0) {
    return "color: #606266;font-weight: bold;"
  }
}
//查询
const formModel = reactive({
  Name: "",
  Application: ""
});
//应用分类
const applicationList = ref<{ title: string; value: number }[]>([]);

//菜单列表列表
let tableData = ref([]);

//获取菜单列表
const getTabelData = () => {
  getMneusList(formModel)
    .then((res) => {
      const { data } = res;
      tableData.value = data;
    })
    .catch((err) => {
      ElMessage.error(err);
    });
};
getTabelData();

//重置搜索
const resetForm = () => {
  formModel.Name = "";
  formModel.Application = "";
  getTabelData();
};

//递归遍历将空数组赋值null
const recursionTree = (treeList: any[]) => {
  treeList.forEach((item) => {
    if (item.children.length == 0) {
      item.children = null;
    } else {
      recursionTree(item.children);
    }
  });
};

//级联选择框的列表数据
const cascaderList = ref([]);

//获取菜单里面的级联选择框数据
const getMenuTreeList = () => {
  getMneusTree()
    .then((res) => {
      res.data.unshift({
        id: "-1",
        parentId: "0",
        title: "顶级",
        value: "0",
        pid: "0",
        children: []
      });
      recursionTree(res.data);

      cascaderList.value = res.data;

    })
    .catch((err) => {
      console.log(err);
    });
};
getMenuTreeList();
//窗口类型
const dialogType = ref("add");

const dialogVisible = ref(false);

//操作表单ref
const dialogRef = ref();

//级联选择框打开时赋值
const selectArr = ref<string[]>([]);

//打开窗口
const openDialog = (type: number, scope: any = {}) => {
  if (type == 1) {
    dialogType.value = "add";
  } else {
    dialogType.value = "edit";
    addForm.value = Object.assign({}, scope);
    addForm.value.pid = scope.pid + "";
  }
  dialogVisible.value = true;

  nextTick(() => {
    dialogRef.value.clearValidate();
  });
};

//关闭窗口
const closeDialog = () => {
  addForm.value = {
    name: "",
    type: "",
    pid: "",
    icon: "",
    router: "",
    sort: "",
    remark: "",
    id: "",
    code: "",
    application: "busiapp"
  };
};

//添加/编辑
let addForm = ref({
  name: "",
  type: "",
  pid: "",
  icon: "",
  router: "",
  sort: "",
  remark: "",
  id: "",
  code: "",
  application: "busiapp"
});

//rules
const formRules = {
  name: [{ required: true, message: "菜单名称不能为空", trigger: "blur" }],
  type: [{ required: true, message: "菜单类型不能为空", trigger: "blur" }],
  pid: [{ required: true, message: "父级id不能为空", trigger: "blur" }],
  icon: [{ required: true, message: "图标不能为空", trigger: "blur" }],
  router: [{ required: true, message: "路由不能为空", trigger: "blur" }],
  sort: [{ required: true, message: "排序不能为空", trigger: "blur" }],
  remark: [{ required: true, message: "备注不能为空", trigger: "blur" }],
  code: [{ required: true, message: "菜单编码不能为空", trigger: "blur" }]
};

//操作提交
const confirm = () => {
  dialogRef.value.validate((vali: any) => {
    if (vali) {
      //添加
      if (dialogType.value == "add") {
        addMenu(addForm.value)
          .then((res) => {

            ElMessage.success("添加成功");
            getTabelData();
            dialogVisible.value = false;

          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        editMenu(addForm.value)
          .then((res) => {

            ElMessage.success("编辑成功");
            getTabelData();
            dialogVisible.value = false;

          })
          .catch((err) => {
            console.log(err);
          });
      }
    } else {
      ElMessage.warning("表单验证失败");
    }
  });
};

//删除菜单
const deleteMenu = (code: number) => {
  const obj = { id: code };
  ElMessageBox.confirm("是否确认删除？", "提示", {
    confirmButtonText: "确认",
    cancelButtonText: "取消",
    type: "warning"
  })
    .then(() => {
      delMenu(obj)
        .then((res: any) => {
          if (res?.code === 200) {
            ElMessage.success("删除成功");
            // 刷新列表
            getTabelData();
          } else {
            ElMessage.error(`删除失败${res?.code}:${res.message}`);
          }
        })
        .catch((err: any) => {
          console.log(err);
          ElMessage.error(`删除失败${err}`);
        });
    })
    .catch(() => {
      ElMessage.info("已取消删除");
    });
};



return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_cascader = _resolveComponent("el-cascader")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_form, {
        model: _unref(formModel),
        "label-width": "106px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 6 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "菜单标题:" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _unref(formModel).Name,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(formModel).Name) = $event)),
                        clearable: "",
                        placeholder: "请输入一级菜单标题"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    icon: "el-icon-search",
                    onClick: getTabelData
                  }, {
                    default: _withCtx(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_button, {
                    icon: "el-icon-refresh-right",
                    onClick: resetForm
                  }, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", null, [
          _createVNode(_component_el_button, {
            type: "primary",
            icon: "el-icon-plus",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (openDialog(1)))
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode(_component_el_table, {
        data: _unref(tableData),
        "row-key": "id",
        "tree-props": { children: 'children', hasChildren: 'hasChildren' },
        border: "",
        style: {"width":"100%"},
        "header-cell-style": rowClass
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            label: "序号",
            align: "center",
            width: "80",
            type: "index"
          }),
          _createVNode(_component_el_table_column, {
            label: "菜单标题",
            prop: "name",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            label: "类型",
            align: "center"
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row.type == 0 ? "目录" : "菜单"), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "路由",
            prop: "router",
            width: "300",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            label: "图标",
            align: "center"
          }, {
            default: _withCtx((scope) => [
              (scope.row.pid == 0)
                ? (_openBlock(), _createElementBlock("i", {
                    key: 0,
                    class: _normalizeClass([scope.row.icon, "iconfont"])
                  }, null, 2))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "备注",
            prop: "remark",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            label: "排序",
            prop: "sort",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            label: "操作",
            width: "260",
            align: "center"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_button, {
                size: "small",
                class: "el-icon-edit",
                onClick: ($event: any) => (openDialog(2, scope.row))
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_el_button, {
                type: "danger",
                size: "small",
                class: "el-icon-delete",
                onClick: ($event: any) => (deleteMenu(scope.row.id))
              }, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((dialogVisible).value = $event)),
      title: dialogType.value == 'add' ? '添加菜单' : '编辑菜单',
      width: "50%",
      onClose: closeDialog
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_9, [
          _createVNode(_component_el_button, {
            onClick: _cache[10] || (_cache[10] = ($event: any) => (dialogVisible.value = false))
          }, {
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: confirm
          }, {
            default: _withCtx(() => [
              _hoisted_11
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _unref(addForm),
          "label-width": "120px",
          ref_key: "dialogRef",
          ref: dialogRef,
          rules: formRules
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "菜单标题:",
                      prop: "name"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _unref(addForm).name,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(addForm).name) = $event)),
                          clearable: "",
                          placeholder: "请输入菜单名称"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "菜单编码:",
                      prop: "code"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _unref(addForm).code,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(addForm).code) = $event)),
                          maxlength: "40",
                          clearable: "",
                          placeholder: "请输入菜单编码"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "上级菜单:",
                      prop: "pid"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_cascader, {
                          modelValue: _unref(addForm).pid,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(addForm).pid) = $event)),
                          "show-all-levels": false,
                          options: cascaderList.value,
                          props: {
              value: 'value',
              label: 'title',
              checkStrictly: true,
              expandTrigger: 'hover',
              emitPath: false
            },
                          clearable: "",
                          size: "large",
                          style: {"width":"100%"}
                        }, null, 8, ["modelValue", "options"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "类型:",
                      prop: "type",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _unref(addForm).type,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(addForm).type) = $event)),
                          placeholder: "请选择菜单类型",
                          size: "large",
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menuTypeList), (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.title,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "路由:",
                      prop: "router"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _unref(addForm).router,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(addForm).router) = $event)),
                          clearable: "",
                          placeholder: "请输入菜单路由"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "图标:",
                      prop: "icon"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _unref(addForm).icon,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(addForm).icon) = $event)),
                          clearable: "",
                          placeholder: "请选择菜单图标"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "排序:",
                      prop: "sort"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _unref(addForm).sort,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(addForm).sort) = $event)),
                          clearable: "",
                          type: "number",
                          min: "1",
                          placeholder: "请输入菜单序号"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "备注:" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _unref(addForm).remark,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(addForm).remark) = $event)),
                          rows: 3,
                          type: "textarea",
                          style: {"width":"100%"},
                          placeholder: "请输入菜单备注"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 64))
}
}

})